<style lang="scss" scoped>
.Preview {
  height: 710px;
  overflow: hidden;
  .setting-prop {
    margin-left: 20px;
    .el-button-group {
      width: 100%;
      margin-bottom: 10px;
      .el-button {
        width: 125px;
      }
    }
    .preview-img {
      background-size: cover;
      width: 375px;
      height: 705px;
    }
    .preview-home {
      // background-image: url(../../../assets/img/u9.png);
    }
    .preview-card {
      // background-image: url(../../../assets/img/u13.png);
    }
    .preview-customer {
      background-image: url(../../../assets/img/u14.png);
    }
  }
}
</style>
<template>
  <div class="Preview">
    <div class="setting-prop">
      <el-button-group>
        <el-button
          size="mini"
          :type="previewBtn == 1 ? 'primary' : ''"
          @click="handleClickBtn(1)"
        >
          首页
        </el-button>
        <el-button
          size="mini"
          :type="previewBtn == 2 ? 'primary' : ''"
          @click="handleClickBtn(2)"
        >
          名片
        </el-button>
        <el-button
          size="mini"
          :type="previewBtn == 3 ? 'primary' : ''"
          @click="handleClickBtn(3)"
        >
          客户详情
        </el-button>
      </el-button-group>
      <div
        v-show="previewBtn == 1"
        class="preview-home preview-img"
      >
        <PreviewHome
          v-if="brand.cover"
          :home-config="{
            headBack: brand.cover.type == 2 ? brand.cover.img : brand.cover.defaultMenusImg,
            topBack: brand.rank.type == 2 ? brand.rank.img : brand.rank.defaultMenusImg,
            navs: navs,
            primaryColor: contentColor
          }"
        />
      </div>
      <div
        v-show="previewBtn == 2"
        class="preview-card preview-img"
      >
        <PreviewCard
          v-if="brand.qrcode"
          :background-img="brand.qrcode.img || brand.qrcode.defaultMenusImg"
        />
      </div>
      <div
        v-show="previewBtn == 3"
        class="preview-customer preview-img"
      >
        <PreviewCustomer
          :content-color="contentColor"
          :primary-color="primaryColor"
          background-img="@/assets/img/guideShopshelf/PreviewCustomer.png"
        />
      </div>
      <PreviewTabbar
        :primary-color="primaryColor"
        :bar-list="tabbars"
        :set-index="previewBtn"
      />
    </div>
  </div>
</template>
<script>
import PreviewCard from './PreviewCard'
import PreviewCustomer from './PreviewCustomer'
import PreviewHome from './PreviewHome'
import PreviewTabbar from './PreviewTabbar'

export default {
  name: 'Preview',
  components: {
    PreviewCard,
    PreviewHome,
    PreviewCustomer,
    PreviewTabbar
  },
  props: {
    primaryColor: {
      type: String,
      default: '#fff'
    },
    backgroundImg: {
      type: String,
      default: ''
    },
    brand: {
      type: Object,
      default: () => {
        return {
          cover: { img: '' },
          rank: { img: '' },
          qrcode: { img: '' }
        }
      }
    },
    navs: {
      type: Array,
      default: () => {
        return []
      }
    },
    tabbars: {
      type: Array,
      default: () => {
        return []
      }
    },
    contentColor: {
      type: String,
      default: '#fff'
    }
  },
  data () {
    return {
      previewBtn: 1
    }
  },
  watch: {
    brand: {
      deep: true,
      handler: function (nv, ov) {
        console.log('[brand]', nv)
      }
    }
  },
  created () {},
  mounted () {
    setTimeout(() => {
      console.log('tabbars', this.tabbars)
    }, 1000)
  },
  methods: {
    handleClickBtn (index) {
      this.previewBtn = index
    }
  }
}
</script>
